var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightPocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9588 8.49112C21.7371 8.26943 21.1378 8.69679 20.8552 8.62136C20.5637 8.54354 20.2557 7.87845 19.9642 7.95627C19.6816 8.03171 19.7467 8.75619 19.525 8.97787C19.3033 9.19956 18.5788 9.13451 18.5034 9.41709C18.4256 9.70862 19.0906 10.0166 19.1685 10.3081C19.2439 10.5907 18.8166 11.19 19.0382 11.4117C19.2599 11.6333 19.8592 11.206 20.1418 11.2814C20.4333 11.3592 20.7413 12.0243 21.0328 11.9465C21.3154 11.8711 21.2503 11.1466 21.472 10.9249C21.6937 10.7032 22.4182 10.7683 22.4936 10.4857C22.5714 10.1942 21.9064 9.88618 21.8285 9.59465C21.7531 9.31207 22.1805 8.7128 21.9588 8.49112Z",
    fill: "#0095DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3422 17.5866C20.3422 17.2964 19.6703 17.1839 19.5347 16.9496C19.3949 16.7079 19.6286 16.0711 19.3869 15.9312C19.1526 15.7957 18.721 16.3124 18.4308 16.3124C18.1407 16.3124 17.7091 15.7957 17.4748 15.9312C17.2331 16.0711 17.4668 16.7079 17.327 16.9496C17.1914 17.1839 16.5195 17.2964 16.5195 17.5866C16.5195 17.8767 17.1914 17.9892 17.327 18.2235C17.4668 18.4653 17.2331 19.1021 17.4748 19.2419C17.7091 19.3775 18.1407 18.8608 18.4308 18.8608C18.721 18.8608 19.1526 19.3775 19.3869 19.2419C19.6286 19.1021 19.3949 18.4653 19.5347 18.2235C19.6703 17.9892 20.3422 17.8767 20.3422 17.5866Z",
    fill: "#0095DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9904 3.68552C10.9484 3.41039 10.2951 3.40091 10.1327 3.19836C9.9651 2.98939 10.0946 2.35175 9.84514 2.25411C9.60337 2.15947 9.26891 2.71183 8.99379 2.7538C8.71866 2.79577 8.23471 2.36827 8.03215 2.5307C7.82319 2.69828 8.1369 3.2683 8.03926 3.51773C7.94462 3.7595 7.32383 3.96338 7.3658 4.2385C7.40777 4.51362 8.06112 4.52311 8.22355 4.72566C8.39113 4.93463 8.26165 5.57227 8.51109 5.66991C8.75286 5.76455 9.08732 5.21219 9.36245 5.17022C9.63758 5.12825 10.1215 5.55575 10.3241 5.39332C10.533 5.22574 10.2193 4.65572 10.317 4.40629C10.4116 4.16452 11.0324 3.96064 10.9904 3.68552Z",
    fill: "#0095DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6267 1.83563C15.4047 1.83563 15.3186 2.34971 15.1393 2.45344C14.9544 2.56045 14.4671 2.38164 14.3601 2.56659C14.2564 2.74586 14.6517 3.07606 14.6517 3.29807C14.6517 3.52008 14.2564 3.85028 14.3601 4.02955C14.4671 4.2145 14.9544 4.03569 15.1393 4.14269C15.3186 4.24641 15.4047 4.76048 15.6267 4.76048C15.8487 4.76048 15.9348 4.24641 16.1141 4.14267C16.299 4.03566 16.7863 4.21447 16.8933 4.02953C16.997 3.85025 16.6016 3.52005 16.6016 3.29804C16.6016 3.07603 16.997 2.74586 16.8933 2.56656C16.7863 2.38161 16.299 2.56043 16.1141 2.45342C15.9348 2.3497 15.8487 1.83563 15.6267 1.83563Z",
    fill: "#0095DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6118 13.0063C13.7375 9.88043 17.3232 10.1917 17.8642 10.2832C18.17 10.3348 18.092 10.7967 17.7866 10.7455C17.2713 10.66 13.8948 10.3861 10.9432 13.3377C10.7268 13.5543 10.3899 13.2281 10.6118 13.0063Z",
    fill: "#4F4E4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3747 10.084C12.401 10.0632 14.7325 8.19274 15.0753 5.4507C15.1136 5.1432 15.5789 5.20091 15.5403 5.50882C15.173 8.44748 12.7669 10.3718 12.6647 10.4523C12.4244 10.6414 12.1278 10.2784 12.3747 10.084Z",
    fill: "#4F4E4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1819 15.3034C16.0256 15.0233 14.4042 12.3903 11.8882 14.3257C11.6422 14.515 11.3567 14.1432 11.6023 13.9542C14.4971 11.7274 16.4113 14.7513 16.5915 15.0755C16.7431 15.3483 16.332 15.5727 16.1819 15.3034Z",
    fill: "#4F4E4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63922 12.0429C10.6722 10.9521 11.0606 9.661 10.7939 8.20559C10.6716 7.5417 10.4291 6.90574 10.0783 6.32903C9.90607 6.07079 10.2964 5.8113 10.4683 6.06902C10.8556 6.69828 11.1224 7.39416 11.2549 8.12108C11.4579 9.22845 11.4014 10.8637 9.9796 12.3652C9.7694 12.5873 9.42311 12.2711 9.63922 12.0429Z",
    fill: "#4F4E4C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11525 9.07589C8.51248 9.07589 8.8345 8.75387 8.8345 8.35664C8.8345 7.95941 8.51248 7.63739 8.11525 7.63739C7.71802 7.63739 7.396 7.95941 7.396 8.35664C7.396 8.75387 7.71802 9.07589 8.11525 9.07589Z",
    fill: "url(#paint0_radial_456_5743)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7905 7.63747C13.1878 7.63747 13.5098 7.31546 13.5098 6.91822C13.5098 6.52099 13.1878 6.19897 12.7905 6.19897C12.3933 6.19897 12.0713 6.52099 12.0713 6.91822C12.0713 7.31546 12.3933 7.63747 12.7905 7.63747Z",
    fill: "url(#paint1_radial_456_5743)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7461 8.35671C17.1433 8.35671 17.4654 8.03469 17.4654 7.63746C17.4654 7.24023 17.1433 6.91821 16.7461 6.91821C16.3489 6.91821 16.0269 7.24023 16.0269 7.63746C16.0269 8.03469 16.3489 8.35671 16.7461 8.35671Z",
    fill: "url(#paint2_radial_456_5743)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.106 13.3913C17.5032 13.3913 17.8252 13.0693 17.8252 12.6721C17.8252 12.2748 17.5032 11.9528 17.106 11.9528C16.7087 11.9528 16.3867 12.2748 16.3867 12.6721C16.3867 13.0693 16.7087 13.3913 17.106 13.3913Z",
    fill: "url(#paint3_radial_456_5743)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5884 16.2682C14.9856 16.2682 15.3076 15.9462 15.3076 15.549C15.3076 15.1517 14.9856 14.8297 14.5884 14.8297C14.1912 14.8297 13.8691 15.1517 13.8691 15.549C13.8691 15.9462 14.1912 16.2682 14.5884 16.2682Z",
    fill: "url(#paint4_radial_456_5743)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57542 20.9085L6.03004 10.5143L13.15 17.6343L2.75591 22.089C2.00996 22.4087 1.25573 21.6544 1.57542 20.9085Z",
    fill: "url(#paint5_linear_456_5743)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71469 20.3923L9.17929 19.3361L3.47225 16.4825L2.66455 18.3672L6.71469 20.3923Z",
    fill: "#0095DA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27979 14.5978L11.6437 18.2798L13.1498 17.6343L11.3699 15.8543L5.08754 12.7131L4.27979 14.5978Z",
    fill: "#0095DA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85678 20.252L1.57542 20.9084C1.25573 21.6544 2.00995 22.4086 2.75591 22.0889L4.25005 21.4486L1.85678 20.252Z",
    fill: "#0095DA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6413 18.1429L5.52134 11.0229C4.84436 10.3459 5.86171 9.32901 6.53848 10.0058L13.6585 17.1258C14.3354 17.8027 13.3181 18.8197 12.6413 18.1429Z",
    fill: "url(#paint6_linear_456_5743)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_456_5743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.11525 8.35664) scale(0.71925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6274,
    stopColor: "#FFD656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA5E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_456_5743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7905 6.91822) scale(0.71925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6274,
    stopColor: "#FFD656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA5E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_456_5743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7461 7.63746) scale(0.71925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6274,
    stopColor: "#FFD656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA5E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_456_5743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.106 12.6721) scale(0.71925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6274,
    stopColor: "#FFD656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA5E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_456_5743",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5884 15.549) scale(0.71925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6274,
    stopColor: "#FFD656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_456_5743",
    x1: 1.76606,
    y1: 21.8983,
    x2: 9.59006,
    y2: 14.0744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6264,
    stopColor: "#D4D4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8657,
    stopColor: "#CDCDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#C5C5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_456_5743",
    x1: 5.29833,
    y1: 14.0744,
    x2: 13.8815,
    y2: 14.0744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6264,
    stopColor: "#D4D4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8657,
    stopColor: "#CDCDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#C5C5DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPocket);
export default __webpack_public_path__ + "static/media/right_pocket.e21ee08dea58efbcbb741f062e809e97.svg";
export { ForwardRef as ReactComponent };